var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserAccessControls01 = function SvgUserAccessControls01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "user_access_controls-01_svg2__a",
    x1: 52.3,
    x2: 154.76,
    y1: 168.56,
    y2: 33.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#user_access_controls-01_svg2__a",
    id: "user_access_controls-01_svg2__b",
    x1: 78.8,
    x2: 181.27,
    y1: 188.74,
    y2: 54.17
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#user_access_controls-01_svg2__a",
    id: "user_access_controls-01_svg2__c",
    x1: 72.59,
    x2: 175.05,
    y1: 184.01,
    y2: 49.44
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m181.28 122.66-6-1.19a58.1 58.1 0 0 0-6.52-15.45l3.48-5.24c.84-1.28.67-2.96-.4-4.05l-13.69-13.69a3.21 3.21 0 0 0-4.07-.4l-5.17 3.45c-4.83-2.86-10.03-5-15.48-6.36l-1.17-5.9v-6.07s.04-5.51-2.76-11.12-8.61-11.48-19.81-11.48v-9.67C109.69 16 93.67 0 74.2 0S38.75 16.01 38.74 35.48l-.02 9.67c-11.21 0-17.03 5.87-19.84 11.48-2.8 5.61-2.76 11.12-2.76 11.12v61.27s-.04 5.51 2.76 11.12 8.66 11.48 19.84 11.48h25.44c1.39 4.65 3.36 9.1 5.87 13.26l-3.55 5.33c-.85 1.28-.68 2.98.4 4.07l13.69 13.67a3.21 3.21 0 0 0 4.07.4l5.21-3.48a57.9 57.9 0 0 0 15.43 6.33l1.21 6.19c.3 1.51 1.63 2.6 3.17 2.6h19.36c1.54 0 2.87-1.09 3.17-2.6l1.21-6.12c5.47-1.35 10.69-3.45 15.55-6.31l5.1 3.38c1.28.85 2.98.68 4.07-.4l13.69-13.67a3.21 3.21 0 0 0 .4-4.07l-3.41-5.12a57.5 57.5 0 0 0 6.33-15.55l6.12-1.21c1.51-.3 2.6-1.63 2.6-3.17v-19.34c0-1.54-1.09-2.87-2.6-3.17ZM45.2 35.48c0-15.94 13.06-29.03 29-29.03s29.03 13.08 29.03 29.03v9.67h-12.9l.02-9.67c0-9.03-6.72-16.14-16.14-16.14s-16.12 7.11-16.12 16.14v9.67h-12.9l.02-9.67Zm38.67 9.67H64.53v-9.67c0-5.9 4.18-9.69 9.67-9.69s9.69 3.8 9.69 9.69zm-59.2 92.1c-2.03-4.07-2.1-8.24-2.1-8.24V67.74s.06-4.17 2.1-8.24c2.03-4.07 5.94-7.91 14.05-7.91h70.96c8.17 0 12.01 3.84 14.05 7.91 2.03 4.07 2.07 8.24 2.07 8.24v3.24h-16.12c-1.54 0-2.87 1.09-3.17 2.6l-1.24 6.14a57.8 57.8 0 0 0-15.29 6.43l-5.33-3.52a3.24 3.24 0 0 0-4.07.4L66.89 96.72a3.22 3.22 0 0 0-.4 4.05l3.5 5.24a57.6 57.6 0 0 0-6.33 15.41l-6.22 1.24c-1.51.3-2.6 1.63-2.6 3.17v19.34H38.72c-8.16 0-12.01-3.84-14.05-7.91Zm152.76 5.27-5.17 1.05a3.22 3.22 0 0 0-2.52 2.52 51.4 51.4 0 0 1-7.22 17.69c-.69 1.08-.68 2.46.02 3.52l2.86 4.26-9.95 9.95-4.26-2.83a3.21 3.21 0 0 0-3.55-.02 51.7 51.7 0 0 1-17.69 7.19 3.21 3.21 0 0 0-2.52 2.55l-1.02 5.14h-14.07l-1.05-5.21a3.21 3.21 0 0 0-2.5-2.52 51.6 51.6 0 0 1-17.55-7.24c-1.08-.7-2.48-.69-3.55.02l-4.41 2.93-9.95-9.95 3-4.5c.73-1.08.74-2.49.02-3.57-3.51-5.32-6-11.23-7.36-17.45a3.23 3.23 0 0 0-2.52-2.48l-5.17-1.05v-14.05l5.24-1.05a3.21 3.21 0 0 0 2.52-2.5 51.6 51.6 0 0 1 7.24-17.55c.7-1.08.69-2.48-.02-3.55l-2.95-4.41 9.95-9.95 4.5 3c1.08.72 2.49.72 3.57 0 5.32-3.51 11.25-6 17.48-7.36a3.23 3.23 0 0 0 2.48-2.52l1.02-5.14h14.07l1.05 5.19a3.21 3.21 0 0 0 2.5 2.52 51.5 51.5 0 0 1 17.62 7.24c1.08.69 2.46.68 3.52-.02l4.36-2.91 9.95 9.95-2.95 4.41a3.22 3.22 0 0 0 0 3.57c3.55 5.35 6.07 11.3 7.43 17.57a3.23 3.23 0 0 0 2.52 2.48l5.02 1.02v14.05Z",
    style: {
      fill: "url(#user_access_controls-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.35 93.56c-23.12 0-41.93 18.81-41.93 41.93s18.81 41.93 41.93 41.93 41.93-18.81 41.93-41.93-18.81-41.93-41.93-41.93m-19.2 71.8c1.19-9.62 9.32-16.96 19.2-16.96s18.03 7.33 19.22 16.95c-5.54 3.56-12.13 5.63-19.22 5.63s-13.67-2.06-19.2-5.62m44.06-4.51c-3.04-10.91-13.07-18.9-24.86-18.9s-21.82 7.98-24.86 18.89a35.35 35.35 0 0 1-10.62-25.34c0-19.64 15.85-35.48 35.48-35.48s35.5 15.85 35.5 35.48c0 9.95-4.07 18.92-10.65 25.35Z",
    style: {
      fill: "url(#user_access_controls-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.35 106.47c-8.87 0-16.12 7.25-16.12 16.12s7.25 16.14 16.12 16.14 16.14-7.28 16.14-16.14-7.28-16.12-16.14-16.12m0 25.81c-5.38 0-9.67-4.31-9.67-9.69s4.28-9.67 9.67-9.67 9.69 4.28 9.69 9.67-4.31 9.69-9.69 9.69",
    style: {
      fill: "url(#user_access_controls-01_svg2__c)"
    }
  }));
};
export default SvgUserAccessControls01;